/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ReactElement } from 'react';
import parse from 'html-react-parser';
import type { BlogContentNodeFragment } from '~/client/components/Blog/graphql/BlogArticleQuery.generated';
import useAgentData from '~/client/hooks/useAgentData';
import useToggle from '~/client/hooks/useToggle';
import type TableOfContent from './@types/tableOfContent';

const useTableOfContents = (page: BlogContentNodeFragment) => {
  const { autoTableOfContents, mainBlock = '' } = page;
  const [showModal, toggleShowModal] = useToggle(false);
  const { isMobile } = useAgentData();

  const tableOfContents: TableOfContent[] = [];

  const addItem = (node: any) => {
    const item = {
      type: node.type as string,
      value: node.props?.children?.props?.children,
      href: `blog_title_${tableOfContents.length}`,
    };
    tableOfContents.push(item);
  };

  if (autoTableOfContents) {
    const nodes = parse(mainBlock) as ReactElement | ReactElement[] | null;

    const nodeArray: ReactElement[] = [];
    if (Array.isArray(nodes)) {
      nodeArray.push(...nodes);
    } else if (nodes) {
      nodeArray.push(nodes);
    }

    nodeArray
      .filter(
        (node: any) =>
          ['h2', 'h3'].includes(node.type as string) &&
          node.props?.children?.type === 'span',
      )
      .forEach((node) => addItem(node));
  }

  return {
    tableOfContents,
    hasModal: isMobile && tableOfContents.length > 0,
    showModal,
    toggleShowModal,
  };
};

export default useTableOfContents;
